<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn depressed class="mx-2" icon text small :to="{ name: 'forma-pagamento-list'}">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span v-if="tituloNovo">Nova forma de pagamento</span>
              <span v-else>Alterar forma de pagamento: {{descricao}}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-text-field
              v-model="descricao"
              :error-messages="descricaoErrors"
              :counter="50"
              label="Descrição"
              required
              @input="$v.descricao.$touch()"
              @blur="$v.descricao.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="codigo_nfe"
              :error-messages="codigonfeErrors"
              :counter="4"
              label="Código NFE"
              required
              @input="$v.codigo_nfe.$touch()"
              @blur="$v.codigo_nfe.$touch()"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, numeric } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    descricao: { required, maxLength: maxLength(50) },
    codigo_nfe: { required, maxLength: maxLength(4), numeric }
  },

  data: () => ({
    id: "",
    descricao: "",
    codigo_nfe: "",
    loading: false,
    tituloNovo: true
  }),

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.maxLength && errors.push("Somente 50 caracteres.");
      !this.$v.descricao.required && errors.push("Descrição é Obrigatório.");
      return errors;
    },
    codigonfeErrors() {
      const errors = [];
      if (!this.$v.codigo_nfe.$dirty) return errors;
      !this.$v.codigo_nfe.maxLength && errors.push("Somente 4 dígitos.");
      !this.$v.codigo_nfe.numeric && errors.push("Somente número");
      !this.$v.codigo_nfe.required && errors.push("Código NFE é Obrigatório.");
      return errors;
    }
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        const success = await this.$store.dispatch("formaPgto/gravar", {
          id: this.id,
          descricao: this.descricao,
          codigo_nfe: this.codigo_nfe
        });
        this.loading = false;
        if (success) {
          this.$router.replace({ path: "lista", name: "forma-pagamento-list" });
        }
      }
    }
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de formas de pagamento"
    });
    this.loading = true;
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      try {
        var response = await this.$store.dispatch(
          "formaPgto/carregarFormaPagamento",
          id
        );
        //console.log(response);
        this.descricao = response.data.descricao;
        this.codigo_nfe = response.data.codigo_nfe;
        //this.preloader = false;
      } catch (err) {
        //deu pau
      }
    }
    this.loading = false;
  }
};
</script>
